<template>
    <div>
        <el-form :inline="true" :model="formInlineList" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="漏斗名称">
                <el-input v-model="formInlineList.hopperName" placeholder="漏斗名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="danger" @click="editFilter(0)">新增漏斗</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="getHopperList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="hopperName" label="漏斗名称"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="addCa(scope.row)">分析</el-button>
                        <el-button type="danger" size="mini"  @click="handledDelete(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="formInline.currentPage"
                :page-sizes="GCONFIG.pageSizes"
                :page-size="formInline.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-drawer
            size="80%"
            title="数据分析"
            :visible.sync="drawer"
            direction="rtl" v-loading="loading">
            <div style="padding: 10px">
                <el-card size="mini" shadow="always" style="margin-bottom: 10px">
                    <div slot="header" class="clearfix">
                        <span>漏斗步骤</span>
                        <div style="float: right">
                            <el-button size="mini" type="danger" @click="editFilter(1)">编辑</el-button>
                        </div>
                    </div>
                    <el-steps :active="filterList.length" align-center process-status="finish" finish-status="finish" >
                        <el-step v-for="item in filterList" :title="item.page"></el-step>
                    </el-steps>
                </el-card>
                <div >
                    <el-card shadow="always" style="min-height: 400px">
                        <div slot="header" class="clearfix">
                            <span>数据展示</span>
                            <div style="float: right">
                                <el-date-picker
                                    v-model="value2"
                                    type="daterange"
                                    align="right"
                                    size="mini"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"

                                    value-format="yyyy-MM-dd"
                                    end-placeholder="结束日期"   :picker-options="pickerOptions">
                                </el-date-picker>

                                <el-button effect="plain" size="mini" @click="searchHopper" >查询</el-button>
<!--                                <el-button effect="plain" size="mini">PV数量</el-button>-->
                            </div>
                        </div>
                        <div>
                            <el-steps :space="100" direction="vertical" :active="5" process-status="process" finish-status="process">
                                <el-step v-for="(item,index) in filterList" icon="el-icon-stopwatch">
                                    <div slot="title">
                                        第{{index+1}}步 {{item.page||'请选择选项'}}
                                        <el-progress :stroke-width="24" :text-inside="true" :color="'#67C23A'" :percentage="item.per" :format="formatCount"></el-progress>
                                    </div>
                                    <div slot="description">
                                        <div style="text-align: center;font-size: 18px;" v-if="item.nextRate!='0'"><i class="el-icon-bottom"></i>{{item.nextRate=='0'?'':item.nextRate}}</div>
                                    </div>
                                </el-step>
                            </el-steps>
                            <el-table :data="detailList" stripe border center :size="GCONFIG.styleTableSize">
                                <el-table-column prop="date" label="时间" ></el-table-column>
                                <el-table-column prop="totalRate" label="总转化率" sortable></el-table-column>
                                <el-table-column
                                    v-for="(item, index) in titleList"
                                    :key="index"
                                    :prop="item.pagevalue"
                                    :label="item.page"
                                    align="center"
                                    min-width="60px">
                                </el-table-column>

                            </el-table>
                        </div>
                    </el-card>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="漏斗筛选" :visible.sync="dialogFormVisible" v-loading="loading">
            <el-form :model="form" label-width="100px">
                <el-form-item label="漏斗名称">
                    <el-input v-model="form.hopperName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="步骤">
                    <el-row v-for="(item,index) in dataList" :key="index" style="margin-bottom: 7px">
                        <el-col :span="22" style="padding-right: 10px">
                          <el-cascader style="width: 60%"
                              v-model="item.pagePath"
                              :options="pages"
                              filterable clearable placeholder="请选择页面/事件" :props="{ checkStrictly: true }"
                              @change="handleChange(item)"></el-cascader>
                            <el-select style="width: 18%" v-model="item.fieldName" filterable clearable placeholder="请选择检索条件" @change="optionsChange(item)">
                                <el-option
                                    v-for="item1 in fieldNames"
                                    :key="item1.dataKey"
                                    :label="item1.dataName"
                                    :value="item1.dataKey">
                                </el-option>
                            </el-select>
                          <el-select style="width:20%" v-model="item.fieldValue" filterable clearable placeholder="请选择条件值" >
                            <el-option
                                v-for="item1 in fieldValues"
                                :key="item1.eventEn"
                                :label="item1.eventCn"
                                :value="item1.eventEn">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="2" >
                            <el-button type="success" icon="el-icon-plus" circle size="small" @click="addInput"></el-button>
                            <el-button v-if="index>0" type="danger" icon="el-icon-minus" circle size="small" @click="decreaseInput(index)"></el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave(form)">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
//导入 HTTP请求方法
import {
  getHopper,
  getDataPages,
  getPageEvents,
  getVisiteLogProp,getVisiteLogPropValue, saveHopper, getHopperBySaved, getHopperPageList, deleteHopper, getDataPagesAndEvents
} from '../../api/api'

//定义组件
export default {
    data() {
        var vue=this;
        return {
            drawer:false,
            selectRow:{},
            dialogFormVisible:false,
            value:'',
            value2:'',
            pages:[],
            events:[],
            fieldNames:[],
            fieldValues:[],
            dataList:[
                {num:1,page:'',pagePath:'',event:'',fieldName:'',fieldValue:''},

            ],
            filterList:[
                // {name:'首页',per:'66%',count:100},
                // {name:'购物车按钮',per:'34%',count:60},
                // {name:'支付页',per:'56%',count:40},
                // {name:'结算',per:'20%',count:20},
            ],
            titleList:[],
            detailList:[],

            getHopperList: [],
            loading: false,
            form: {
                hopperName: '',
                id:null,

            },
            formInline: {
                hopperName: "",
                channId:null,
                customerLevel:null,
                sdate:'',
                edate:'',
                currentPage: 1,
                pageSize: 10,
                recordsTotal: 0,
            },
          formInlineList: {
            hopperName: "",
            currentPage: 1,
            pageSize: 10,
            recordsTotal: 0,
          },
            pickerOptions:{
            onPick(time){
              if(time==null){
                return;
              }
              console.log(time.minDate);
              vue.formInline.sdate=time.minDate;
              vue.formInline.edate=time.maxDate;


            }
          },

        }
    },
    //挂载时候执行
    mounted() {
        //获取查询条件下拉列表
        //getQueryList({}).then((res) => {
      this.getList();
      getDataPagesAndEvents().then((res) => {
        if (res.data.status == 200) {
          this.pages = res.data.value;
          //console.log(res.data.value)
        }
      });
      getVisiteLogProp().then((res) => {
        if (res.data.status == 200) {
          this.fieldNames = res.data.value;
          //console.log(res.data.value)
        }
      });
        //});
    },
    methods: {
      searchHopper(){

        if(this.formInline.sdate!=null&&this.formInline.edate!=null){
          var s=JSON.parse(this.selectRow.hopperFilter);
          this.dataList=s;
          this.form.hopperName=this.selectRow.hopperName;
          this.form.id=this.selectRow.id;
          this.loading=true;
          getHopper({"seachStr":JSON.stringify(this.dataList),"sdate":this.formInline.sdate,"edate":this.formInline.edate,"chanId":this.formInline.channId,
            "customerLevel":this.formInline.customerLevel}).then((res) => {
            this.loading=false;
            //console.log(res);
            if(res.data.success){
              this.filterList=[];
              var last=1;
              for(var d of res.data.value.total){
                if(d.type==2){
                  d.per=parseFloat(d.rate.replace('%',''))*last;
                  last=d.per/100;
                  this.filterList.push(d);
                  this.formInline.sdate=d.sdate;
                  this.formInline.edate=d.edate;
                  this.value2=[this.formInline.sdate,this.formInline.edate];
                  console.log(this.value2);
                }
              }

              this.detailList=res.data.value.detail;
              this.titleList=res.data.value.titles;

            }else{
              this.$message({
                message:res.data.message,
                type:'error'
              });
            }
          });
        }else{
          this.$message({
            showClose: true,
            message: "请选择日期范围",
            type: 'error'
          });
        }

      },
        //定义查询方法
        getList() {
            this.loading = true;
            getHopperPageList(this.formInlineList).then((res) => {
                this.loading = false;
                if (res.data.status == 200) {
                    this.$message({
                        showClose: true,
                        message: '查询成功',
                        type: 'success'
                    });
                    this.formInline.recordsTotal = res.data.value.total;
                    this.getHopperList = res.data.value.list;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        //新增漏斗
        addCa(row){
            this.drawer = true;
            this.filterList=[];
            this.detailList=[];
            this.selectRow=row;
            getHopperBySaved({"hopperId":row.id}).then((res) => {
            if (res.data.status == 200) {
              var last=1;
              for(var d of res.data.value.total){
                if(d.type==2){
                  d.per=parseFloat(d.rate.replace('%',''))*last;
                  last=d.per/100;
                  this.filterList.push(d);
                  this.formInline.sdate=d.sdate;
                  this.formInline.edate=d.edate;
                  this.value2=[this.formInline.sdate,this.formInline.edate];
                  console.log(this.value2);
                }
              }

              this.detailList=res.data.value.detail;
              this.titleList=res.data.value.titles;

            }
          });

        },

      // optionClick(item){
      //   //console.log(item);
      //   this.optionsChange(item);
      // },
        optionsChange(item){

          //this.$set(item,'percent',this.options[item.inputVal].count)
          //this.$set(item,'title',this.options[item.inputVal].label)
          //console.log(this.pages[item.pagePath].page);
          if(item.pagePath==''){
            this.$message({
              showClose: true,
              message: '请先选择页面/事件',
              type: 'error'
            });
            item.fieldName='';
            return;
          }
          console.log(item)
          getVisiteLogPropValue({"pagePath":item.pagePath,"field":item.fieldName}).then((res) => {
            if (res.data.status == 200) {
              this.fieldValues = res.data.value;
            }
          });
        },
        formatCount(val){
          for(var d of this.filterList){
            if(d.type==2&&d.per==val){
              return d.uv;
            }
          }
            //return val+'%';
        },
        addInput(){
            this.dataList.push({num:this.dataList.length+1,page:'',pagePath:'',event:''},)
        },
        decreaseInput(index){
            this.dataList.splice(index,1)
        },
        editFilter(edit){
            this.dialogFormVisible = true
          if(edit==1){
            var s=JSON.parse(this.selectRow.hopperFilter);
            this.dataList=s;
            for(var d of this.dataList){
              var pagePath=d.pagePath;
              var event=d.event;
              if(event!=''){
                d.pagePath=[pagePath,event];
              }

            }
            this.form.hopperName=this.selectRow.hopperName;
            this.form.id=this.selectRow.id;
          }else{
            this.selectRow={};
            this.form.hopperName='';
            this.form.id=null;
            this.dataList=[
              {num:1,page:'',pagePath:'',event:''},

            ];
          }

        },
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.getList()
        },
        handleCurrentChange(val) {
            this.formInline.currentPage = val;
            this.getList()
        },
        handledDelete(row) {
          if(confirm("确定删除漏斗:"+row.hopperName+"吗？")) {
            deleteHopper({id: row.id}).then((res) => {
              if (res.data.status == 200) {
                this.$message({
                  showClose: true,
                  message: '成功',
                  type: 'success'
                });
                this.getList(this.currentPage, this.pageSize);
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'error'
                });
              }

            })
          }
        },
      handleChange(value) {
        console.log(value);
        var pagePath=value.pagePath[0];
        var event=value.pagePath.length>1?value.pagePath[1]:'';
        value.pagePath=pagePath;
        value.event=event;
        for(var p of this.pages){
          if(p.value==value.pagePath){
            value.page=p.label;
            break;
          }
        }
        console.log(value);
      },
        handleSave(form){
          if(this.form.hopperName==''){
            this.$message({
              message:"请输入漏斗名称",
              type:'error'
            });
            return;
          }
          var i=1;
          for (var d of this.dataList) {
            console.log(d);
            if(d.page==''){
              this.$message({
                message:"第"+i+"行请选择漏斗条件",
                type:'error'
              });
              return;
            }
            i++;
          }
          this.loading=true;
          saveHopper({"seachStr":JSON.stringify(this.dataList),"sdate":this.formInline.sdate,"edate":this.formInline.edate,"chanId":this.formInline.channId,
          "customerLevel":this.formInline.customerLevel,"hopperName":this.form.hopperName,"id":this.form.id}).then((res) => {
            this.loading=false;
            //console.log(res);
            if(res.data.success){
              this.$message({
                message:res.data.message,
                type:'success'
              });
              this.dialogFormVisible=false;
              this.getList();
              if(this.form.id!=null){
                this.addCa(this.selectRow);
              }

            }else{
              this.$message({
                message:res.data.message,
                type:'error'
              });
            }
          });
        }
    }
}
</script>
<style  scoped>
.el-step:last-of-type .el-step__description{
    opacity: 0;
}


</style>



// WEBPACK FOOTER //
// src/views/monitor/analysisCa.vue